export const THEME_PRIMARY = 'THEME_PRIMARY';
export const THEME_SECONDARY = 'THEME_SECONDARY';
export const THEME_WARNING = 'THEME_WARNING';
export const THEME_MUTED = 'THEME_MUTED';
export const THEME_RED = 'THEME_RED';
export const THEME_WHITE = 'THEME_WHITE';
export const THEME_BLACK = 'THEME_BLACK';
export const THEME_GREY = 'THEME_GREY';
export const THEME_SILVER = 'THEME_SILVER';
export const THEME_ALU = 'THEME_ALU';
export const THEME_LIGHTGREY = 'THEME_LIGHTGREY';
export const THEME_SMOKY = 'THEME_SMOKY';

// These colors are used in badges to simulate opacity 0.5 because the background is not always white and with opacity the background would be visible through the badge
export const THEME_GREEN_LIGHT = 'THEME_GREEN_LIGHT';
export const THEME_ORANGE_LIGHT = 'THEME_ORANGE_LIGHT';

const colors = {
    black: '#000000',
    grey: '#7a7a7a',
    alu: '#979797',
    paynes: '#aaaaaa',
    silver: '#c5c5c5',
    smoky: '#e6e6e6',
    lightGrey: '#f2f2f2',
    white: '#ffffff',
    orange: '#f07e32',
    orangeLight: '#fbc19a',
    green: '#7fc31c',
    greenLight: '#bdde8d',
    darkRed: '#d0021b'
};

const colorsTheme = {};
colorsTheme[THEME_PRIMARY] = colors.green;
colorsTheme[THEME_SECONDARY] = colors.grey;
colorsTheme[THEME_WARNING] = colors.orange;
colorsTheme[THEME_MUTED] = colors.paynes;
colorsTheme[THEME_RED] = colors.darkRed;
colorsTheme[THEME_WHITE] = colors.white;
colorsTheme[THEME_BLACK] = colors.black;
colorsTheme[THEME_GREY] = colors.grey;
colorsTheme[THEME_SILVER] = colors.silver;
colorsTheme[THEME_ALU] = colors.alu;
colorsTheme[THEME_LIGHTGREY] = colors.lightGrey;
colorsTheme[THEME_SMOKY] = colors.smoky;
colorsTheme[THEME_GREEN_LIGHT] = colors.greenLight;
colorsTheme[THEME_ORANGE_LIGHT] = colors.orangeLight;

export function themeColor(param: string) {
    if (!colorsTheme.hasOwnProperty(param)) {
        throw new Error(`${param} is not a defined color.`);
    }
    return colorsTheme[param];
}

export function textColor(param: string) {
    if (!colorsTheme.hasOwnProperty(param)) {
        throw new Error(`${[param]} is not a defined color.`);
    }
    return `color: ${colorsTheme[param]}`;
}

export function borderColor(param: string) {
    if (!colorsTheme.hasOwnProperty(param)) {
        throw new Error(`${[param]} is not a defined color.`);
    }
    return `border-color: ${colorsTheme[param]}`;
}
